import { render } from "./physicalinspectionApproval.vue?vue&type=template&id=051ee221&scoped=true"
import script from "./physicalinspectionApproval.vue?vue&type=script&lang=js"
export * from "./physicalinspectionApproval.vue?vue&type=script&lang=js"

import "./physicalinspectionApproval.vue?vue&type=style&index=0&id=051ee221&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-051ee221"]])

export default __exports__